

module.exports = __webpack_require__.stylable.create(
    "UserMessage1129588052",
    {"classes":{"root":"UserMessage1129588052__root","messageText":"UserMessage1129588052__messageText","messageButton":"UserMessage1129588052__messageButton"},"vars":{},"stVars":{},"keyframes":{}},
    "",
    8,
    "UserMessage1129588052",
    null
);
